import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';

import * as S from './style';
import CheckboxInput from './checkbox-input';
import ErrorComponent from './error-component';
import RecaptchaInputWrapper from './recaptcha-input-wrapper';

const Input = ({ field, style }) => {
  const { t } = useTranslation();
  const { errors, touched } = useFormikContext();
  const { name, Component, tkey, options, mandatory } = field;

  useEffect(() => {
    if (!Component) {
      console.error(name, 'field is missing component!');
    }
  }, []);

  const hasError = touched[name] && errors[name];
  const hasLabel = ![CheckboxInput, RecaptchaInputWrapper].includes(Component);

  if (!Component) {
    return null;
  }
  return (
    <div key={name} style={style ? style : null}>
      {hasLabel ? (
        <S.Label htmlFor={name}>
          {t(tkey)}
          {mandatory ? <span className="red">*</span> : ''}
        </S.Label>
      ) : null}
      <Component
        name={name}
        tkey={tkey}
        options={options}
        mandatory={mandatory}
        touched={touched[name]}
        error={hasError ? errors[name] : null}
      />
      <ErrorComponent name={name} />
    </div>
  );
};

export default Input;

Input.propTypes = {
  field: PropTypes.object,
  style: PropTypes.any,
};
